module.exports = __webpack_public_path__ + "static/media/roller03.4d350e80.png";